import axios from '../utils/axios';

export const registerSchool = async (data) => {
  const response = await axios.post('/school', data);
  return response.data;
};

export const updateSchool = async (data) => {
  let { school } = JSON.parse(localStorage.getItem('school'));
  let id = school.id;
  const response = await axios.put(`/schools/${id}`, data);
  return response.data;
};

export const getSchoolArms = async () => {
  const res = await axios.get(`/school-arms`);
  return res.data;
};
export const getSchoolClasses = async () => {
  const res = await axios.get(`/classes`);
  return res.data;
};

export const getCountries = async () => {
  const res = await axios.get(`/countries`);
  return res.data;
};
export const getLanguages = async () => {
  const res = await axios.get(`/languages`);
  return res.data;
};

export const getSchoolSubjects = async () => {
  const res = await axios.get(`/subjects`);
  return res.data;
};

export const verifySchool = async (data) => {
  let { school } = JSON.parse(localStorage.getItem('school'));
  let id = school.id;

  const response = await axios.put(`/schools/${id}/verify`, data);
  return response.data;
};

export const resendOTP = async (data) => {
  const response = await axios.put(`/otp`, data);
  return response.data;
};
